import * as yup from 'yup';

export const cpuAndMemoryRangeValidationSchema = yup.object({
  cpu: yup.number().min(0).max(100).required('CPU is required'),
  memory: yup.number().min(0).max(100).required('Memory is required'),
});
